<template>
	<div class="c-resource-detail">
		<ps-tools-resources-header :active="activeSection" @setActiveSection="setActive"></ps-tools-resources-header>
		<div v-if="resource" class="c-my-resources container">
			<div class="row mt-15">
				<div class="col-12 col-md-2">
					
					<div class="row justify-content-between">
						<img class="col-4 col-md-12 mb-5" :src="getImageUrl(resource, 'cover', 175, 220)" alt="Cover" />
						<div class="col-8 d-md-none">
							<div class="text-oceanblue font_24_32 font-weight-bold">{{resource.title}}</div>
							<div class="text-grey font_14_16 mb-8">Uploaded {{resource.created_at}} by "{{resource.user.first_name}} {{resource.user.last_name}}"</div>
						</div>
					</div>
					
					<div class="row justify-content-between mb-12 mb-md-0">
						<div class="col-6 col-md-12 mb-md-2">
							<a v-if="resourceUrl" :href="resourceUrl" target="_blank" class="c-button c-button--style-1 w-100">Go to link</a>
						</div>
						<!-- <div class="col-6 col-md-12">
							<a href="#" class="c-button c-button--style-2 d-flex align-items-center justify-content-center w-100" @mouseover="editIconColor = '#FFFFFF'"  @mouseleave="editIconColor = '#248A86'">
								<icon-edit :color="editIconColor"  class="mr-2" /><span>Edit details</span>
							</a>
						</div> -->
					</div>
				</div>
				<div class="col-12 col-md-7">
					<div class="d-flex justify-content-between">
						<div>
							<div class="text-oceanblue font_24_32 font-weight-bold d-none d-md-block">{{resource.title}}</div>
							<div class="text-grey font_14_16 mb-8 d-none d-md-block">Uploaded {{resource.created_at}} by "{{resource.user.first_name}} {{resource.user.last_name}}"</div>
						</div>
						<template v-if="authenticated">
							<a v-if="isImportant(resource)" href="#" class="d-flex align-items-center" @click.prevent="saveResource(resource.id)"><span class="text-oceanblue font_14_19 mr-4">Remove from saves?</span> <icon-important /></a>
							<a v-else href="#" class="d-flex align-items-center" @click.prevent="saveResource(resource.id)"><span class="text-grey font_14_19 mr-4">Save for later?</span> <icon-bookmark color="#C4C4C4" /></a>
						</template>
					</div>
					<div class="mb-8 text-darkgrey">
						<p>{{resource.description}}</p>
					</div>
					<div v-if="resource.use" class="row mb-2">
						<div class="col-12 col-md-3 font_14_19 text-primary font_weight_500">How is this helpful</div>
						<div class="col-12 col-md-9 font_14_19 text-darkgrey">{{resource.use}}</div>
					</div>
					<div class="row mb-8">
						<div class="col-12 col-md-3 font_14_19 text-primary font_weight_500">Category themes</div>
						<div class="col-12 col-md-9 font_14_19 text-darkgrey">
							<span v-for="theme in resource.themes" :key="theme.id" class="c-theme-link text-oceanblue">{{theme.title}}</span>
							<!-- <a v-for="theme in resource.themes" :key="theme.id" :href="`/themes/${theme.slug}`" class="c-theme-link text-oceanblue">{{theme.title}}</a> -->
						</div>
					</div>
					<div class="font_14_19 text-grey">{{resource.document_type}}</div>
					<div class="c-meta font_14_19 text-grey d-flex mb-12">
						<span v-if="resource.language" class="c-meta__item d-flex align-items-center">Language: {{resource.language}}</span>
						<span v-if="resource.un_region" class="c-meta__item">Location: {{resource.un_region}}</span>
					</div>
					<hr class="mb-12" />
					<ps-card-grid title="Resource collaborations" subtitle="A list of authors and collaborators for this Resource" no-gutters>
						<ps-image-card
							v-for="city in resource.cities"
							:key="city.id"
							:image="getImageUrl(city, 'city_image')"
							class="col-12 col-md-6 col-lg-4 mb-8"
							:meta="['Region', 'Country']"
							elevated
						>
							<span slot="title" class="d-block font_16_21 font-weight-bold text-black">City Name</span>
						</ps-image-card>
						<!-- <ps-card
							class="col-12 col-md-6 col-lg-4 mb-8"
							title="Profile Name"
							thumbnail="http://loremflickr.com/78/78/avatar"
							subtitle="User Type"
							description="Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore."
							:meta="['Region', 'Country']"
							showFullDescription
							rounded-image
							elevated
						></ps-card> -->
						<ps-card
							v-if="resource.organizations.length"
							class="col-12 col-md-6 col-lg-4 mb-8"
							title="Organizations"
							showFullDescription
							elevated
						>
							<template v-for="(organization, index) in resource.organizations">
								<div :key="index">
									<div class="font_14_19 text-darkgrey mb-2">{{organization}}</div>
									<hr v-if="index + 1 != resource.organizations.length" class="mb-2" />
								</div>
							</template>
						</ps-card>
						<ps-card
							v-if="resource.researchers.length"
							class="col-12 col-md-6 col-lg-4 mb-8"
							title="Authors"
							showFullDescription
							elevated
						>
							<template v-for="(researcher, index) in resource.researchers">
								<div :key="index">
									<div class="font_14_19 text-darkgrey mb-2">{{researcher}}</div>
									<hr v-if="index + 1 != resource.researchers.length" class="mb-2" />
								</div>
							</template>
						</ps-card>
					</ps-card-grid>
					<hr class="mb-12" />
					<ps-card-grid title="Recently viewed" no-gutters>
						<ps-resource-card v-for="resource in recentlyViewedResources" :key="resource.id" :resource="resource" elevated show-full-description></ps-resource-card>
					</ps-card-grid>
				</div>
				<div class="col-12 col-md-3">
					<div class="bg-white u-elevated p-5 mb-8">
						<div class="text-oceanblue font-weight-bold font_16_21 mb-5">Share this resource</div>
						<div class="d-flex">
							<ShareNetwork
								class="d-block mr-2"
								network="facebook"
								:url="currentUrl"
								:title="resource.title"
								:description="resource.description"
							>
								<icon-facebook-round />
							</ShareNetwork>
							<ShareNetwork
								class="d-block mr-2"
								network="twitter"
								:url="currentUrl"
								:title="resource.title"
							>
								<icon-twitter-round />
							</ShareNetwork>
							<ShareNetwork
								class="d-block mr-2"
								network="linkedin"
								:url="currentUrl"
								:title="resource.title"
							>
								<icon-linkedin-round />
							</ShareNetwork>
							<!-- <a href="#" class="d-block mr-2"><icon-link-round /></a> -->
							<ShareNetwork
								class="d-block mr-2"
								network="whatsapp"
								:url="currentUrl"
								:title="resource.title"
							>
								<icon-whatsapp-round />
							</ShareNetwork>							
						</div>
					</div>
					<div v-if="tagsArray.length" class="bg-white u-elevated mb-8">
						<div class="text-oceanblue font-weight-bold font_16_21 px-5 pt-5">Resource tags</div>
						<div class="d-flex flex-wrap m-5">
							<!-- <a href="#" v-for="tag in tagsArray" :key="tag" class="c-tag mb-5">{{ tag }}</a> -->
							<span href="#" v-for="tag in tagsArray" :key="tag" class="c-tag mb-5">{{ tag }}</span>
						</div>
					</div>
					<div class="bg-white u-elevated mb-8">
						<div class="text-oceanblue font-weight-bold font_16_21 px-5 pt-5">Similar tools and resources</div>
						<div v-for="(similarResource, index) in similarResources" :key="similarResource.id">
							<a class="d-block" :href="`/tools-and-resources/${similarResource.id}`">
								<ps-card
									:thumbnail="getImageUrl(similarResource, 'cover')"
									:title="similarResource.title"
									:subtitle="similarResource.short_title"
									:description="similarResource.description"
									stacked
								></ps-card>
							</a>
							<hr v-if="index != similarResources.length - 1" class="mx-5" />
						</div>
					</div>
					<div class="bg-white u-elevated mb-8">
						<div class="text-oceanblue font-weight-bold font_16_21 px-5 pt-5">More resources uploaded by {{resource.user.first_name}} {{resource.user.last_name}}</div>
						<div v-for="(userResource, index) in myLatestResources" :key="userResource.id">
							<a class="d-block" :href="`/tools-and-resources/${userResource.id}`">
								<ps-card
									:thumbnail="getImageUrl(userResource, 'cover')"
									:title="userResource.title"
									:subtitle="userResource.short_title"
									:description="userResource.description"
									stacked
								></ps-card>
							</a>
							<hr v-if="index != resource.user.resources - 1" class="mx-5" />
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import IconFacebookRound from '../../icons/IconFacebookRound.vue'
import resource from '../../graphql/queries/resource.gql'
import resourceListQuery from '../../graphql/queries/resourceList.gql'
import mediaMethods from '../../mixins/MediaMethods'
import resourceMethods from '../../mixins/ResourcesMethods'
import {setCookie, getCookie} from '../../helpers/Cookies'
import { mapGetters } from 'vuex';

export default {
    components: { IconFacebookRound },
	name: 'PsResourceDetail',
	data: () => ({
		activeSection: 'resourceSearch',
		resource: null,
		similarResources: null,
		tagsArray: [],
		recentlyViewedResources: [],
		editIconColor: '#248A86',
	}),
	props: {
		id: {
			required: true
		}
	},
	apollo: {
		resource: {
			query: resource,
			variables () {
				return {
					id: this.id,
				}
			},
			result(ApolloQueryResult, key) {
				this.tagsArray = []
				ApolloQueryResult.data.resource.tags.forEach(tag => {
					if (tag.approved) {
						this.tagsArray.push(tag.name)
					}
				});
			}
		},
		similarResources: {
			query: resourceListQuery,
			variables () {
				return {
					limit: 5,
					search: {
						searchTags: this.tagsArray
					},
				}
			},
			update: data => data.resources
		},
	},
	methods: {
		setActive(section) {
			
			switch (section) {
				case 'resourceSearch':
					window.location.href = '/tools-and-resources'
					break;
				case 'myResources':
					window.location.href = '/tools-and-resources#myResources'
					break;
				case 'UploadResource':
					window.location.href = '/tools-and-resources#UploadResource'
					break;
			
				default:
					window.location.href = '/tools-and-resources'
					break;
			}
		},

		saveResource(id) {
			const token = localStorage.getItem(process.env.MIX_TOKEN_STORE_NAME)

			const config = {
				headers: { Authorization: `Bearer ${token}` }
			};

			this.$axios.post('save-resource', {
				resource_id: id
			}, config)
			.then(response => {
				console.log(response.data)
				this.$apollo.queries.resource.refetch()
			})
			.catch(error => {
				console.log(error)
			});
		}
	},
	computed: {
		...mapGetters({
			authenticated: 'authenticated',
			me: 'getMe',
		}),

		currentUrl() {
			return window.location.href
		},

		resourceUrl() {
			var prefix = 'https://';

			if (!this.resource.url) {
				return false
			}

			if (this.resource.url.substr(0, prefix.length) !== prefix) {
				return prefix + this.resource.url;
			}

			return this.resource.url;
		},

		myLatestResources() {
			return this.resource.user.resources.slice(0, 5)
		}
	},
	created() {
		//Update recently viewed resources list
		var recentlyViewedResources = getCookie('recentlyViewedResources')
		
		if (!recentlyViewedResources) {
			recentlyViewedResources = []
		}
		else {
			recentlyViewedResources = JSON.parse(recentlyViewedResources)

			//Set the data for use on this page
			this.$apollo.query({
				query: resourceListQuery,
				variables: {
					id: recentlyViewedResources,
				},
			}).then((response) => {
				this.recentlyViewedResources = response.data.resources
			}).catch((error) => {
				console.error(error)
			})
		}

		//Add this id to recently viewed list
		if (!recentlyViewedResources.includes(this.id)) {
			//Ensure there are never more than 3 recently viewed items
			if (recentlyViewedResources.length >= 3) {
				recentlyViewedResources.pop()
			}
			recentlyViewedResources.push(this.id)
		}

		setCookie('recentlyViewedResources', JSON.stringify(recentlyViewedResources), 30)
	},
	mixins: [mediaMethods, resourceMethods]
}
</script>

<style lang="scss" scoped>
	.c-theme-link {
		&:after {
			content: ', '
		}

		&:last-child:after {
			content: none;
		}
	}

	.c-meta {

		&__item {
			margin-right: 12px;
			
			&:after {
				content: '';
				width: 4px;
				height: 4px;
				border-radius: 50%;
				background-color: $grey;
				margin-left: 12px;
			}

			&:last-child {
				margin-right: 0;

				&:after {
					content: none;
				}
			}
		}
	}
</style>